import { makeStyles } from "@material-ui/core";

export const RESET_STATE_PO_BARANG = {
  id: "",
  // po_id: "",
  namabarang: "",
  barang_id: "",
  satuan_id: null,
  namasatuan: "Pilih Satuan",
  qty: 1,
  harga: "0",
  harga2: "0",
  disc: "",
  statUpdate: false,
};

export const STYLE_WMS_PO = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  // {
  //   id: "hargabeli",
  //   disablePadding: false,
  //   label: "HARGA BELI",
  //   align: "left",
  // },
];
